'use client'

import { Calendar } from 'react-feather'
import { useRouter, useTranslations } from '@/lib/next-shim'

import { FormSubmission } from '@/core/graphql/types'
import { ConsultationCard, ConsultationCardProps } from '@/entities/consultation'

import { DashboardCarousel } from './DashboardCarousel'
import { DashboardSection } from './DashboardSection'

type ConsultationForSection = ConsultationCardProps['consultation']

type Consultation = ConsultationForSection & {
  formSubmissions?: FormSubmission[]
}

type ConsultationsProps = {
  consultations: Consultation[]
}

export function Consultations({ consultations }: ConsultationsProps) {
  const t = useTranslations()
  const hasConsultations = consultations.length > 0

  return (
    <DashboardSection title={t('account.sections.Consultations.title')} count={consultations.length} viewAllHref="/account/consultations">
      <ConsultationsList consultations={consultations} />
    </DashboardSection>
  )
}

function ConsultationsList({ consultations }: { consultations: Consultation[] }) {
  const router = useRouter()
  const t = useTranslations()

  if (!consultations.length) {
    return (
      <div className="mx-5 flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-gray-200 bg-white px-6 py-10 text-center">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Calendar size={22} aria-hidden="true" />
        </span>
        <p className="text-sm font-semibold text-gray-900">{t('account.sections.Consultations.empty')}</p>
        <p className="max-w-xs text-sm text-gray-500">{t('account.sections.Consultations.emptyHint')}</p>
      </div>
    )
  }

  return (
    <DashboardCarousel
      items={consultations}
      getItemKey={(consultation) => consultation._id}
      slideTestId="consultation-card"
      renderItem={(consultation) => (
        <ConsultationCard
          className="!w-full cursor-pointer"
          consultation={consultation}
          onClick={() => router.push(`/account/consultations/${consultation._id}`)}
        />
      )}
    />
  )
}
